import type { ReactNode } from "react";
import { SwotAlert } from "../feedback/SwotAlert.js";

export function SwotPwaUpdateNotice(props: { readonly title?: string | undefined; readonly children?: ReactNode | undefined; readonly actions?: ReactNode | undefined }) {
  return (
    <SwotAlert title={props.title ?? "Application update available"} tone="info">
      {props.children}
      {props.actions ? <div className="swot-pwa-update-notice__actions">{props.actions}</div> : null}
    </SwotAlert>
  );
}
